import { render, staticRenderFns } from "./OfficialHolidaysPlans.vue?vue&type=template&id=7f282dc2&"
import script from "./OfficialHolidaysPlans.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports